<template>
  <ShowControl  @revert="revertClick"  :title="title" ref="showControl">
    <div style="width: 90%;margin-top: 2%;">
      <!-- <h1 style="text-align: center; margin-bottom: 10px">收入管理</h1> -->
      <el-table :data="
          IncomeList
        "
                style="width: 100%;height: 85%;"
                empty-text="暂无数据"
                v-loading="loding">
        <el-table-column prop="createTime"
                        label="收入日期"
                        align="center">
          <template #default="scope">
            <label>{{filter.formatDate(scope.row.createTime, "yyyy-M-d")}}</label>
          </template>
        </el-table-column>
        <el-table-column prop="buissType"
                        label="收入类型"
                        align="center">
          <template #default="scope">
            <label>{{Global.IncometTypes.filter(c=>c.id==scope.row.buissType)[0]?.name}}</label>
          </template>
        </el-table-column>
        <el-table-column prop="buissValue"
                        label="收入金额"
                        align="center">
          <template #default="scope">
            <span>{{String(scope.row.buissValue).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}元</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="IncomeInput.currentPage"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="IncomeInput.pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="IncomeTotal"
                    style="display: flex; justify-content: center; margin-top: 10px">
      </el-pagination>
    </div>
  </ShowControl>
</template>
<script>
import { mapState } from "vuex";
import ShowControl from "../../UserControl/ShowControl.vue"
export default {
  props: ["department"],
  data () {
    return {
      loding: false,
      caseID: localStorage.getItem("caseId"),
      IncomeList: [],
      IncomeTotal: 0,
      IncomeInput:
      {
        incometType: this.Global.IncometType.income,
        round: null,
        currentPage: 1,
        pagesize: 10
      },
      title: '收入管理'
    };
  },
  components: {ShowControl},
  computed: {
    ...mapState({
      Round: (state) => state.user.round,
      ChatShow:(state) => state.user.chatShows,
    }),
  },
  created () {
    this.GetExpenditureInfo();
  },
  mounted() {
    this.$refs.showControl.receiveValue(true);
  },
  methods: {
    revertClick(){
      this.$router.push("/FinancialManagement")
    },
    handleSizeChange: function (size) {
      this.IncomeInput.pagesize = size;
      this.GetExpenditureInfo();
    },
    //当前页码
    handleCurrentChange: function (currentPage) {
      this.IncomeInput.currentPage = currentPage;
      this.GetExpenditureInfo();
    },
    GetExpenditureInfo () {
      this.loding = true
      this.IncomeInput.round = this.Round;
      this.$http.post('Income/GetAllIncome', this.IncomeInput).then((res) => {
        if (res.success) {
          this.IncomeList = res.dynamicObj;
          // for (let index = 0; index < this.IncomeList.length; index++) {
          //   this.IncomeList[index].createTime = dayjs(this.IncomeList[index].createTime).format('YYYY-MM-DD')
          // }
          this.IncomeTotal = res.totalRecord;
          this.$store.commit("chatShow",{ isOperate : !this.ChatShow, chatValue: this.Global.OperateType.查看收入管理 });  
          this.loding = false
        }
      })
    }
  },
};
</script>

<style scoped>
</style>